<template>
  <div class="h-full w-full max-w-screen-xs mx-auto relative">
    <div
      class="bg-dark z-[200] relative h-full max-w-[540px] mx-auto flex flex-col justify-between"
    >
      <FontIcon
        class="icon-close text-dark-200 py-4 px-6 cursor-pointer"
        :height="24"
        data-test-id="btn_close"
        :width="24"
        @click.prevent="emit('close')"
      />

      <div class="px-6 pt-5 pb-6 h-full flex flex-col justify-between">
        <div>
          <div class="flex flex-col items-left gap-2 mb-4">
            <SvgIcon name="heart_smart_match" :width="40" :height="40" />

            <h2 class="text-headline5 font-semibold gradient-text">
              {{ t('activated') }}
            </h2>
          </div>
          <div class="flex flex-col gap-1">
            <p class="text-body2 text-dark-500">{{ t('popularity') }}</p>

            <p class="text-caption text-dark-200">
              {{ t('turnOff') }}
            </p>
          </div>
        </div>

        <SmartAiButton @click="emit('close')">{{ t('ok') }}</SmartAiButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

import SmartAiButton from '@/components/inputs/button/SmartAiButton.vue';
import FontIcon from '@/components/inputs/icon/font-icon/FontIcon.vue';
import SvgIcon from '@/components/inputs/icon/svg-icon/SvgIcon.vue';
import { bq } from '@/services/bq/bq';
import { useI18n } from '@/services/i18n';

import { messages } from './i18n';

const props = defineProps<{ source: string }>();
const emit = defineEmits<{
  (e: 'close'): void;
}>();

const { t } = useI18n({ messages });

onMounted(() => {
  bq.track('page_show', {
    page_name: 'ai_success',
    block: 'product',
    source: props.source,
  });
});
</script>

<style scoped lang="scss">
.gradient-text {
  background: linear-gradient(123deg, #0f7 0%, #b9ffec 25%, #2eeaff 50%, #00ffc3 85%);
  background-clip: text;
  color: transparent;
  width: fit-content;
}
</style>
